import { JsonObject, JsonProperty } from 'typescript-json-serializer';

export enum LayoutType {
    DESKTOP = 'DESKTOP',
    TABLET = 'TABLET',
    MOBILE = 'MOBILE',
    A4 = 'A4',
}

export enum LayoutElementType {
    WIDGET = 'WIDGET',
    ANALYSIS = 'ANALYSIS',
    RICH_TEXT = 'RICH_TEXT',
    BUSINESS_INSIGHT = 'BUSINESS_INSIGHT',
    // Used for A4 layouts
    A4_HEADER = 'A4_HEADER',
    A4_FOOTER = 'A4_FOOTER',
}

const NON_ANALYSIS_LAYOUT_ELEMENTS = new Set<LayoutElementType>([
    LayoutElementType.RICH_TEXT,
    LayoutElementType.BUSINESS_INSIGHT,
    LayoutElementType.A4_HEADER,
    LayoutElementType.A4_FOOTER,
]);

export const isAnalysisLayoutElement = (type: LayoutElementType): boolean => !NON_ANALYSIS_LAYOUT_ELEMENTS.has(type);

export type ConstraintsPerLayoutElement = {
    type: LayoutType;
    minWidth: number;
    minHeight: number;
    maxWidth: number;
    maxHeight: number;
};

export type LayoutElement = {
    id: string;
    position: { x: number; y: number };
    type: LayoutElementType;
    size: { width: number; height: number };
    constraints: {
        minWidth: number;
        maxWidth: number;
        minHeight: number;
        maxHeight: number;
    };
};

@JsonObject()
export class LayoutElementClass {
    constructor(
        @JsonProperty({ required: true }) readonly id: string,
        @JsonProperty({ required: true }) readonly position: { x: number; y: number },
        @JsonProperty({ required: true }) readonly type: LayoutElementType,
        @JsonProperty({ required: true }) readonly size: { width: number; height: number },
        @JsonProperty({ required: true })
        readonly constraints: {
            minWidth: number;
            maxWidth: number;
            minHeight: number;
            maxHeight: number;
        }
    ) {}
}

@JsonObject()
export default class Layout {
    constructor(
        @JsonProperty({ required: true }) readonly type: LayoutType,
        @JsonProperty({ required: true }) readonly widgets: LayoutElementClass[]
    ) {}
}
